import { ReactiveFormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'

import { WalletConfigDetailComponent } from './components/wallet-config-detail/wallet-config-detail.component'
import { WalletConfigListComponent } from './components/wallet-config-list/wallet-config-list.component'
import { WalletRulesComponent } from './components/wallet-rules/wallet-rules.component'
import { ProgressSpinnerModule } from 'primeng/progressspinner'
import { InputTextareaModule } from 'primeng/inputtextarea'
import { SharedModule } from '@shared/shared.module'
import { CalendarModule } from 'primeng/calendar'
import { CheckboxModule } from 'primeng/checkbox'
import { SkeletonModule } from 'primeng/skeleton'
import { TimelineModule } from 'primeng/timeline'
import { ButtonModule } from 'primeng/button'
import { DialogModule } from 'primeng/dialog'
import { ToastModule } from 'primeng/toast'
import { CardModule } from 'primeng/card'
import { TagModule } from 'primeng/tag'
import { InputTextModule } from 'primeng/inputtext'
import { DropdownModule } from 'primeng/dropdown'
import { MultiSelectModule } from 'primeng/multiselect'
import { TooltipModule } from 'primeng/tooltip'
import { ConfirmDialogModule } from 'primeng/confirmdialog'


@NgModule({
  declarations: [
    WalletConfigListComponent,
    WalletConfigDetailComponent,
    WalletRulesComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CardModule,
    ButtonModule,
    DialogModule,
    CalendarModule,
    InputTextareaModule,
    CheckboxModule,
    ToastModule,
    ProgressSpinnerModule,
    SkeletonModule,
    TagModule,
    TimelineModule,
    SharedModule,
    InputTextModule,
    DropdownModule,
    MultiSelectModule,
    TooltipModule,
    ConfirmDialogModule
  ]
})
export class WalletConfigModule { }